import { render, staticRenderFns } from "./SearchSummaryTable.vue?vue&type=template&id=fbd8b1d4&scoped=true&"
import script from "./SearchSummaryTable.vue?vue&type=script&lang=js&"
export * from "./SearchSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./SearchSummaryTable.vue?vue&type=style&index=0&id=fbd8b1d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd8b1d4",
  null
  
)

export default component.exports